import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { Section } from './ui/Section';
import { CTAButton } from './ui/CTAButton';
export function Hero() {
  const bullets = ['estás más irritable de lo normal y luego te castigas por ello', 'necesitas 10 minutos a solas y la culpa te come', "te cuesta descansar incluso cuando el día 'ya ha terminado'", 'sientes que has desaparecido detrás del rol de madre/padre'];
  return <Section className="pt-10 md:pt-20 pb-12" data-id="element-68">
      <FadeIn data-id="element-69">
        <h1 className="text-3xl md:text-5xl font-bold text-charcoal leading-[1.2] mb-6 tracking-tight text-center" data-id="element-70">
          Cuando por fin hay silencio… tu cabeza no para.
        </h1>
      </FadeIn>

      <FadeIn delay={0.1} data-id="element-71">
        <p className="text-lg md:text-xl text-gray leading-relaxed mb-4 text-center" data-id="element-72">
          El Permiso es una guía breve (20 min) para madres y padres agotados:
          recupera espacio mental, baja la culpa y vuelve a tener paciencia sin
          convertirlo en otro curso más.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-73">
        <p className="text-base md:text-lg font-medium text-charcoal mb-6 text-center" data-id="element-74">
          En 20 minutos tendrás un plan simple para esta misma noche.
        </p>
      </FadeIn>

      <FadeIn delay={0.3} className="mb-8" data-id="element-75">
        <div className="relative max-w-lg mx-auto" data-id="element-76">
          <div className="absolute inset-0 bg-bg-alt rounded-2xl -rotate-1 scale-[1.02]" data-id="element-77" />
          <img src="https://cdn.magicpatterns.com/uploads/nqBTePU6cNpRofTmQfaMSk/elpermiso.png" alt="El Permiso — Manual de recuperación de identidad parental" className="relative w-full rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.08)] object-cover" data-id="element-78" />
        </div>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-79">
        <CTAButton className="mb-8" data-id="element-80" />
      </FadeIn>

      <FadeIn delay={0.5} data-id="element-81">
        <div className="border-y border-border py-3 my-8" data-id="element-82">
          <p className="text-xs text-gray font-medium tracking-wide text-center" data-id="element-83">
            +4.500 copias descargadas · Lectura rápida (20 min) · Formato móvil
            · Aplicable hoy
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.6} data-id="element-84">
        <h3 className="text-base md:text-lg font-semibold text-charcoal mb-4" data-id="element-85">
          Te va a encajar si…
        </h3>
      </FadeIn>

      <StaggerContainer className="space-y-4 mb-8" data-id="element-86">
        {bullets.map((bullet, index) => <StaggerItem key={index} className="flex items-start gap-3" data-id="element-87">
            <div className="w-1.5 h-1.5 rounded-full bg-sage mt-2.5 flex-shrink-0" data-id="element-88" />
            <p className="text-charcoal text-base md:text-lg" data-id="element-89">{bullet}</p>
          </StaggerItem>)}
      </StaggerContainer>

      <FadeIn delay={0.8} data-id="element-90">
        <p className="text-sm text-gray italic text-center mt-8" data-id="element-91">
          No es crianza. No es disciplina. Es una herramienta para ti.
        </p>
      </FadeIn>
    </Section>;
}